// extracted by mini-css-extract-plugin
export default {"container":"SharedLesson_container__1ECDR","card":"SharedLesson_card__DnsrC","message":"SharedLesson_message__N+xx7","button":"SharedLesson_button__XdXlX"};